import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'gatsby-plugin-intl'

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 8%;
`
const SubmitButton = styled.button`
  background: #fac700;
  padding: 6px;
  color: #404040;
  font-weight: bold;
  font-size: 16px;
  border-radius: 5px;
  width: 150px;
  border:none;
  -webkit-transition: all 0.5s ease-in-out 0s;
  transition: all 0.5s ease-in-out 0s;
`

SubmitButton.defaultProps = {
  buttonColor: '#fac700'
}

const InputBox = ({ buttonColor }) => {
  return (
    <Container className="container">
        <SubmitButton buttonColor={buttonColor}>
          <FormattedMessage id="SubmitButton" />
        </SubmitButton>
    </Container>
  )
}

export default InputBox
